import { Button, Tooltip } from '@material-ui/core';

import CustomButton from '../common/buttons/custom-button';
import { SubstitutionFlow } from 'features/order/substitution-flow';

import useStyles from './OrderDetailDialogActionsBox.styles';

function OrderDetailDialogActionsBox(props) {
  const {
    cancelButtonText,
    canceledMarketplaceOrderButtonText,
    canceledPickupOrderButtonText,
    deliveredToRTText,
    notDeliveredToRTText,
    onClickCanceledMarketplaceOrderButton,
    onClickCanceledPickupOrderButton,
    onClickDeliveredToRT,
    onClickNotDeliveredToRT,
    onClickOrderReadyButton,
    onClickDeliverButton,
    onClickRejectButton,
    order,
    partnerId,
    showActionBox,
    isBeingManaged,
    showCanceledFullDeliveryOrderActions,
    showCanceledMarketplaceOrderActions,
    showCanceledPickupOrderActions,
    showCookingOrderActions,
    showPendingToDeliverOrderActions,
    storekeeperId,
    storeId,
    isOrderReadyButtonEnabled,
    orderReadyButtonDisclaimerText,
    cookingLabelButton,
    pendingDeliveryLabelButton,
    showCancelBtnToMP,
  } = props;

  const _clases = useStyles();

  if (!showActionBox) {
    return isBeingManaged ? (
      <div className={_clases.root}>
        <SubstitutionFlow orderId={order.id} />
      </div>
    ) : null;
  }
  return (
    <div className={_clases.root}>
      {showCanceledFullDeliveryOrderActions && (
        <>
          <CustomButton
            classes={{ submitButton: _clases.customButtonSecondaryRoot }}
            onClick={async () => {
              await onClickNotDeliveredToRT(
                order.id,
                partnerId,
                storekeeperId,
                storeId,
              );
            }}
            variant='outlined'
          >
            {notDeliveredToRTText}
          </CustomButton>
          <CustomButton
            classes={{ submitButton: _clases.customButtonSecondaryRoot }}
            onClick={async () => {
              await onClickDeliveredToRT(
                order.id,
                partnerId,
                storekeeperId,
                storeId,
              );
            }}
            variant='outlined'
          >
            {deliveredToRTText}
          </CustomButton>
        </>
      )}
      {showCanceledMarketplaceOrderActions && (
        <CustomButton
          classes={{ submitButton: _clases.customButtonSecondaryRoot }}
          onClick={async () => {
            await onClickCanceledMarketplaceOrderButton(order.id);
          }}
          variant='outlined'
        >
          {canceledMarketplaceOrderButtonText}
        </CustomButton>
      )}
      {showCanceledPickupOrderActions && (
        <CustomButton
          classes={{ submitButton: _clases.customButtonSecondaryRoot }}
          onClick={async () => {
            await onClickCanceledPickupOrderButton(order.id);
          }}
          variant='outlined'
        >
          {canceledPickupOrderButtonText}
        </CustomButton>
      )}

      {showCancelBtnToMP && (
        <Button
          fullWidth
          variant='outlined'
          onClick={onClickRejectButton}
          classes={{ root: _clases.cancelBtnToMP }}
        >
          {cancelButtonText}
        </Button>
      )}

      <SubstitutionFlow orderId={order.id} />

      {showCookingOrderActions && (
        <>
          <OrderReadyButtonTooltipWrapper
            condition={!isOrderReadyButtonEnabled}
            wrapper={children => (
              <Tooltip
                classes={{ tooltip: _clases.tooltip }}
                title={orderReadyButtonDisclaimerText}
                placement='left-start'
                arrow
              >
                {children}
              </Tooltip>
            )}
          >
            <Button
              variant='contained'
              disabled={!isOrderReadyButtonEnabled}
              classes={{ root: _clases.cookingPrimaryBtn }}
              onClick={async () => await onClickOrderReadyButton(order)}
            >
              {cookingLabelButton}
            </Button>
          </OrderReadyButtonTooltipWrapper>
        </>
      )}
      {showPendingToDeliverOrderActions && (
        <CustomButton
          onClick={async () => {
            await onClickDeliverButton(order.id);
          }}
          variant='contained'
        >
          {pendingDeliveryLabelButton}
        </CustomButton>
      )}
    </div>
  );
}

export default OrderDetailDialogActionsBox;

function OrderReadyButtonTooltipWrapper({ condition, wrapper, children }) {
  return condition ? wrapper(children) : children;
}
